const tooltipConfig = (config) => ({
  enabled: true,
  backgroundColor: '#FAFDFF',
  titleColor: '#000000',
  titleFont: {
    weight: '600',
    family: 'Poppins'
  },
  bodyColor: '#000000',
  bodyFont: {
    weight: '400',
    family: 'Poppins'
  },
  borderWidth: 1,
  padding: 10,
  cornerRadius: 6,
  displayColors: false,
  ...config
})

export {
  tooltipConfig
}